import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      {/* Leadership */}
      <section className="section section-alt leadership">
        <div className="container">
          <h2 className="section-title">Leadership</h2>
          <div className="leader-profile">
            <div className="leader-image">
              <img src="/rob1.png" alt="Robert Dixon - Financial Advisor & President" className="leader-photo" />
            </div>
            <div className="leader-info">
              <h3>Robert Dixon, CFS</h3>
              <p className="leader-title">Financial Advisor & President</p>
              
              <div className="leader-bio">
                <h4>Professional Background</h4>
                <p>
                  Robert Dixon began his career in financial services in 1993 at A.G. Edwards, where he developed 
                  his expertise in comprehensive financial planning and investment management. After spending 10 
                  successful years at Renaissance Financial, Robert founded Dixon Financial Services in 2004 with 
                  a vision to provide truly objective advice and better access to institutional money managers for 
                  individual investors.
                </p>
                
                <div className="leader-contact">
                  <h4>Contact Information</h4>
                  <p><strong>Phone:</strong> <a href="tel:314-961-6100">314-961-6100</a></p>
                  <p><strong>Email:</strong> <a href="mailto:rob@dixonfinancialservices.com">rob@dixonfinancialservices.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community Involvement */}
      <section className="section community-involvement">
        <div className="container">
          <div className="community-header">
            <h2 className="section-title">Community Involvement</h2>
            <p className="community-intro">
              Rob believes in giving back to the community and actively participates in organizations 
              that make a positive impact on people's lives.
            </p>
          </div>
          <div className="community-activities">
            <div className="activity-card enhanced">
              <div className="activity-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21.54 15H17a2 2 0 0 0-2 2v4.54"/>
                  <path d="M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17"/>
                  <path d="M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05"/>
                  <circle cx="12" cy="12" r="10"/>
                </svg>
              </div>
              <div className="activity-content">
                <h3>Past President</h3>
                <h4>Hostelling International</h4>
                <p>Served as President, supporting affordable travel and cultural exchange opportunities that connect people across cultures and communities.</p>
              </div>
            </div>
            <div className="activity-card enhanced">
              <div className="activity-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m3 11 18-5v12L3 14v-3z"/>
                  <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
                </svg>
              </div>
              <div className="activity-content">
                <h3>Guest Speaker</h3>
                <h4>American Cancer Society</h4>
                <p>Regular contributor to financial wellness seminars and educational programs, helping individuals navigate financial challenges during difficult times.</p>
              </div>
            </div>
            <div className="activity-card enhanced">
              <div className="activity-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 5a2 2 0 0 0-2 2v11"/>
                  <path d="M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>
                  <path d="M7 13h10"/>
                  <path d="M7 9h10"/>
                  <path d="M9 5a2 2 0 0 0-2 2v11"/>
                </svg>
              </div>
              <div className="activity-content">
                <h3>Adult Swim Coach</h3>
                <h4>Mid-County YMCA</h4>
                <p>Volunteer coach helping adults develop swimming skills and water safety, promoting health and wellness in the community.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Professional History */}
      <section className="section section-alt professional-history">
        <div className="container">
          <div className="history-content">
            <h2>Professional & Regulatory History</h2>
            <p>
              We believe in transparency and encourage you to review our professional background 
              and regulatory history.
            </p>
            <a 
              href="https://brokercheck.finra.org/individual/summary/2376039" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              FINRA Professional History
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 